<template>
  <button
    :disabled="disabled || loading"
    :class="[
      'flex justify-center rounded-md border border-transparent  px-4 py-2 text-sm font-normal text-white-500 shadow-sm focus:outline-hidden focus:ring-2 focus:ring-primary-500 focus:ring-offset-2',
      loading ? ['bg-primary-50 hover:bg-primary-50'] : '',
      disabled ? 'bg-neutral-400' : 'bg-primary-500 hover:bg-primary-600 ',
    ]"
    :data-test="'TButtonInline-' + dataTestName"
    @click="action"
  >
    <TIcon v-if="loading" name="loader" class="mr-2 h-5 w-5 animate-spin" />
    <span v-if="!loading">
      <slot />
    </span>
  </button>
</template>

<script setup lang="ts">
defineProps({
  loading: { type: Boolean, required: false, default: false },
  action: { type: Function, required: false, default: null },
  dataTestName: { type: String, required: false, default: '' },
  disabled: { type: Boolean, required: false, default: false },
});
</script>
